// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-content-header-moment {
  position: relative;
  width: 100%;
  height: 100%;
}

.side-panel-image-moment {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.panel-content-moment-icons {
  font-size: 22px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: absolute;
  bottom: 1%;
  right: 0;
  align-items: end;
}

.panel-content-moment-reactions {
  display: flex;
  align-items: center;
  color: var(--planeed-color-white);
  gap: 5px;
}

.panel-content-moment-user-data {
  font-size: 16px;
  color: var(--planeed-color-white);
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: absolute;
  bottom: 0;
  left: 3%;
}

.user-data {
  display: flex;
  align-items: center;
}

.user-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid var(--planeed-color-white);
  background-color: var(--planeed-color-white);
  object-fit: cover;
  overflow: hidden;
  filter: drop-shadow(1px 1px 2px rgba(37, 37, 37, 0.3));
}
.user-image img {
  border-radius: 50%;
}

.moment-timestamp {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.24px;
  margin-top: 5px;
  margin-bottom: 5px;
  filter: drop-shadow(1px 1px 2px rgba(37, 37, 37, 0.3));
}

.moods-row {
  text-align: left;
  padding-right: 20px;
  padding-bottom: 0;
}
.moods-row .moods {
  margin-left: auto;
  margin-right: 0;
  width: fit-content;
}
.moods-row .moods ion-icon {
  height: 24px;
  width: 24px;
  fill: #ffffff;
  filter: drop-shadow(1px 1px 2px rgba(37, 37, 37, 0.3));
}
.moods-row .moods ion-button {
  display: flex;
  margin: 0;
  --padding-start: 0px;
  --padding-end: 0px;
}

.moodPopover {
  --width: 46px;
  background-color: transparent;
  align-items: center;
}
.moodPopover .popRow {
  margin: 5px 3px;
}
.moodPopover .popRow .moodButtonContent {
  width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.moodPopover .popRow .moodButtonContent .moodPopIcon {
  height: 18px;
  width: 18px;
}
.moodPopover .popRow .moodButtonContent .moodPopIcon:hover {
  cursor: pointer;
}
.moodPopover .popRow .moodButtonContent .moodName {
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: 6px;
  color: var(--ion-color-secondary);
}

.moods-count {
  padding-right: 5px;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 21px;
  color: var(--planeed-color-white);
}

.action-point-icon {
  height: 24px;
  width: 24px;
  fill: #ffffff;
  cursor: pointer;
  filter: drop-shadow(1px 1px 2px rgba(37, 37, 37, 0.3));
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
